import { controlPlaneRouting, requestRegionRoutes } from './generated/routing';

const toMatchers = (
  routeList: readonly { method: string; endpoint: string }[]
) =>
  routeList.map(({ method, endpoint }) => ({
    method,
    pattern: new RegExp(
      `^${endpoint
        .split('/')
        .map((segment) =>
          segment.startsWith('{') && segment.endsWith('}')
            ? '[^/]+'
            : segment.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        )
        .join('/')}$`
    ),
  }));

const routes = toMatchers(controlPlaneRouting.routes);
const regionRoutes = toMatchers(requestRegionRoutes);

export function getControlPlaneRequestUrl(method: string, url: URL): URL {
  const origin = controlPlaneRouting.origins[url.origin];
  if (
    !origin ||
    !routes.some(
      (route) => route.method === method && route.pattern.test(url.pathname)
    )
  ) {
    return url;
  }
  const target = new URL(url);
  target.host = new URL(origin).host;
  return target;
}

/**
 * Whether the API places this request by its `x-data-region` header or its
 * path instead of the `x-team-id` team's own region.
 */
export function isRequestRegionRoute(method: string, url: URL) {
  return regionRoutes.some(
    (route) => route.method === method && route.pattern.test(url.pathname)
  );
}
